import {
    FETCH_IRIS_S1_TARGETER,
    FETCH_IRIS_S1_TARGETER_SUCCESS,
} from '../actionTypes/IRISS1TargeterActionTypes';

export const getIRISS1Targeter = (payload) => ({
    type: FETCH_IRIS_S1_TARGETER,
    payload,
});

export const loadIRISS1Targeter = (payload) => ({
    type: FETCH_IRIS_S1_TARGETER_SUCCESS,
    payload,
});

export default {
    getIRISS1Targeter,
    loadIRISS1Targeter,
};
